/* eslint-disable */
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import React, { createContext, useContext } from 'react'
import { tokenExpire } from '../Utils';
const FileUploadContext = createContext(null);
import { useHistory } from 'react-router-dom';
import { get } from '../Network/requests';
import { getUrl } from '../Network/urls';
import toast from 'react-hot-toast';
import AppContext from './AppContext';
const FileUploadProvider = ({ children }) => {
    const {
        clientDetails,
        handleEncryptOtherParamsOfAPI,
        handleDecryptResponse,
        handleAPIEncryptValue,
        // handleDecryptedValue,
    } = useContext(AppContext);
    const [isDragOver, setIsDragOver] = useState(false);
    const [debouncedIsDragOver, setDebouncedIsDragOver] = useState(false);
    const controllerRef = useRef(null);
    const [progress, setProgress] = useState(0);
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [showAbortIcon, setShowAbortIcon] = useState(false);
    const history = useHistory();
    const fileInputRef = useRef(null);

    const overlayTimer = useRef(null);

    // for non-interactive file upload
    const [isUploading, setIsUploading] = useState(false);


    const handleDragOver = (e) => {
        const hasFiles = Array.from(e.dataTransfer.types).includes('Files');
        if (hasFiles) {
            e.preventDefault();
            if (!isDragOver) setIsDragOver(true);
        }
    };

    const handleDragLeave = (e) => {
        const hasFiles = Array.from(e.dataTransfer.types).includes('Files');
        if (hasFiles) {
            e.preventDefault();
            setIsDragOver(false);
        }
    };

    const handleDrop = (e, onDrop) => {
        const hasFiles = Array.from(e.dataTransfer.types).includes('Files');
        if (hasFiles) {
            e.preventDefault();
            onDrop(e.dataTransfer.files[0])
            setIsDragOver(false);
        }
    };

    const handleStopUploadOperation = () => {
        if (controllerRef.current) {
            try {
                controllerRef.current.abort();
                toast.error("Upload cancelled", { autoClose: 1000 });
            } catch (e) {
                console.error("Abort failed:", e);
            }
        }
        setProgress(0);
        setShowProgressBar(false);
        controllerRef.current = null;
        setShowAbortIcon(false);
    };
    const uploadFileToS3 = async ({ presignedURL, inputFile, showController = false, onProgress = undefined }) => {
        const controller = showController ? new AbortController() : undefined;
        if (controller !== null) controllerRef.current = controller;
        try {
            const res = await axios.put(presignedURL, inputFile, {
                signal: showController ? controller.signal : undefined,
                headers: {
                    'Content-Type': inputFile?.type
                },
                onUploadProgress: onProgress
            });
            return res;
        } catch (error) {
            throw error;
        }
    };
    // email
    // file_name
    // s3_path
    // product_code
    // regulation_code
    // client_id
    // client_name
    // uploaded_at

    const getPresignedURL = async ({ fName, regulationFolder, productCode, regulationCode, bucketName }) => {
        const url = getUrl('get-presigned-url');
        try {
            const key = `${regulationFolder}${fName}`;
            const paramsObj = {
                productCode,
                regulationCode,
                clientId: clientDetails?.clientId,
                clientName: clientDetails?.clientName,
                key,
                bucketName,
                region: clientDetails?.region,
                clientId: clientDetails?.clientId,
            };
            // console.log('paramsObj :', paramsObj);
            const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
            const data = {
                email_id: clientDetails?.email,
                product_code: encryptedParamsObj?.productCode,
                regulation_code: encryptedParamsObj.regulationCode,
                client_id: encryptedParamsObj.clientId,
                client_name: encryptedParamsObj.clientName,
                key: encryptedParamsObj?.key,
                bucket_name: encryptedParamsObj?.bucketName,
                region: encryptedParamsObj?.region,
            };
            // console.log('data :', data);
            const regassureData = handleAPIEncryptValue(JSON.stringify(data));
            const res = await get(`${url}?regassuredata=${regassureData}`, true,);
            const {
                data: { encryptBody, authData, statusCode },
            } = res;
            const iv = authData;
            const idToken = localStorage.getItem('RegAssureVal7');
            const secretKey = idToken?.slice(-32);
            const body = handleDecryptResponse(encryptBody.toString(),
                secretKey.toString(), iv.toString());
            switch (statusCode) {
                case 200:
                    return body?.URL;
                case 401:
                    throw new Error('Unauthorized Access');
                default:
                    throw new Error(body);
            }
        } catch (error) {
            console.log('failed to generate the presigned URL')
            throw error;
        }
    }

    const onProgress = (e) => {
        if (e.lengthComputable) {
            const fProgress = Math.round((e.loaded / e.total) * 100);
            setProgress(fProgress);
            if (fProgress < 100) {
                setShowAbortIcon(true);
            } else {
                setShowAbortIcon(false);
            }
        }
    }

    const uploadInputFile = async ({
        uploadFile,
        fName,
        regulationFolder,
        productCode,
        regulationCode,
        bucketName = 'input',
    }) => {
        setShowProgressBar(true);
        setShowAbortIcon(false);
        setProgress(0);

        try {
            if (!fName || !productCode || !regulationFolder) {
                throw new Error('Missing required parameters to upload. Please try again');
            }
            const presignedURL = await getPresignedURL({ fName, regulationCode, regulationFolder, productCode, bucketName });
            if (presignedURL) {
                setShowAbortIcon(true);
                const res = await uploadFileToS3({
                    presignedURL, onProgress, inputFile: uploadFile, showController: true
                });

                switch (res.status) {
                    case 200:
                        toast.success("File Uploaded Successfully");
                        setProgress(100);
                        if (overlayTimer.current) {
                            clearInterval(overlayTimer.current);
                        }
                        overlayTimer.current = setTimeout(() => {
                            setShowProgressBar(false);
                            setProgress(0);
                        }, 500); // show overlay for short time after upload
                        break;
                    case 403:
                        throw new Error('Unauthorized. Please try again');
                    default:
                        throw new Error("Upload failed");
                }
            }
        } catch (error) {
            if (error?.message !== 'canceled')
                toast.error(error?.message);
            console.log('error :', error);
            if (error?.message === 'Unauthorized Access') {
                tokenExpire(error, 401)
            }
            setShowProgressBar(false);
        }
        finally {
            if (fileInputRef.current) {
                fileInputRef.current.value = ''
            }
            setShowAbortIcon(false);
        }
    };

    // upload hold trades, reconcile seed file etc  
    const uploadLogicalData = async ({
        uploadFile,
        fName,
        regulationFolder,
        productCode,
        regulationCode,
        bucketName = 'input',
        successToast = "Hold Trades Uploaded Successfully",
    }) => {
        try {
            if (!fName || !productCode || !regulationFolder) {
                throw new Error('Missing required parameters to upload. Please try again');
            }
            const presignedURL = await getPresignedURL({ fName, regulationCode, regulationFolder, productCode, bucketName });
            // const presignedURL = await new Promise((resolve) => setTimeout(() => resolve, 1000));
            // console.log('presignedURL :', presignedURL);
            if (presignedURL) {
                const res = await uploadFileToS3({
                    presignedURL, inputFile: uploadFile
                });

                switch (res.status) {
                    case 200:
                        if (successToast?.message) {
                            toast.success(successToast.message, successToast.options);
                        } else {
                            toast.success(successToast);
                        }
                        return {
                            status: 'success',
                            httpStatus: res.status,
                            fileName: fName,
                            regulationFolder,
                            productCode,
                            regulationCode,
                            bucketName,
                        };
                    case 403:
                        throw new Error('Unauthorized. Please try again');
                    default:
                        throw new Error("Upload failed");
                }
            }
        } catch (error) {
            toast.error(error?.message);
            console.log('error :', error);
            if (error?.message === 'Unauthorized Access') {
                tokenExpire(error, 401)
            }
            return {
                status: 'error',
                message: error?.message || 'Upload failed',
                fileName: fName,
                regulationFolder,
                productCode,
                regulationCode,
                bucketName,
            };
        }
        finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedIsDragOver(isDragOver);
        }, 200);

        return () => clearTimeout(timeout);
    }, [isDragOver]);

    return (
        <FileUploadContext.Provider value={{ showProgressBar, progress, setProgress, setShowProgressBar, showAbortIcon, setShowAbortIcon, handleDragOver, handleDragLeave, handleDrop, isDragOver, setIsDragOver, debouncedIsDragOver, setDebouncedIsDragOver, handleStopUploadOperation, fileInputRef, isUploading, setIsUploading, uploadFileToS3, uploadInputFile, uploadLogicalData }}>
            {children}
        </FileUploadContext.Provider>
    )
}

const useFileUpload = () => useContext(FileUploadContext)
export { FileUploadProvider, useFileUpload }
